/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type employee_absences_UpdateAbsenceRequest = {
    /**
     * Type of absence: VACATION, SICK, PERSONAL, TRAINING, OTHER, ACCIDENT, COMP_TIME, or CHILD_SICK
     */
    absence_type: employee_absences_UpdateAbsenceRequest.absence_type;
    /**
     * Timestamp of when the absence was last updated, used for optimistic locking (RFC3339 format)
     * Optional: newly created absences may not have an updated_at timestamp yet
     */
    current_updated_at?: string;
    /**
     * Start date of the absence in ISO 8601 format (YYYY-MM-DD)
     */
    from_date: string;
    /**
     * Start time for partial-day absences in HH:MM format (required if full_day is false)
     */
    from_time?: string;
    /**
     * Whether this is a full-day absence (defaults to true when omitted from request)
     */
    full_day?: boolean;
    /**
     * Optional notes about the absence
     */
    notes?: string;
    /**
     * End date of the absence in ISO 8601 format (YYYY-MM-DD)
     */
    to_date: string;
    /**
     * End time for partial-day absences in HH:MM format (required if full_day is false)
     */
    to_time?: string;
};
export namespace employee_absences_UpdateAbsenceRequest {
    /**
     * Type of absence: VACATION, SICK, PERSONAL, TRAINING, OTHER, ACCIDENT, COMP_TIME, or CHILD_SICK
     */
    export enum absence_type {
        VACATION = 'VACATION',
        SICK = 'SICK',
        PERSONAL = 'PERSONAL',
        TRAINING = 'TRAINING',
        OTHER = 'OTHER',
        ACCIDENT = 'ACCIDENT',
        COMP_TIME = 'COMP_TIME',
        CHILD_SICK = 'CHILD_SICK',
    }
}

